import { render } from "./SiteExperience.vue?vue&type=template&id=8c28f0d0&scoped=true"
import script from "./SiteExperience.vue?vue&type=script&lang=js"
export * from "./SiteExperience.vue?vue&type=script&lang=js"

import "./SiteExperience.vue?vue&type=style&index=0&id=8c28f0d0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rexvalkering-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c28f0d0"]])

export default __exports__